import { Box } from '@mui/material'
import Image from 'next/image'

import { theme } from 'styles/theme'

export type CustomerAvatarProps = {
  name?: string | null
  logoUrl?: string | null
  size?: number
}

const getInitials = (name?: string | null) => {
  if (!name) return '?'
  // Sufixos entre parênteses são comuns nos nomes ("... Prequé (RP)") e o
  // primeiro caractere da última palavra virava pontuação: "E(".
  const words = name
    .trim()
    .split(/\s+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean)
  if (words.length === 0) return '?'
  if (words.length >= 2) {
    return `${words[0][0]}${words[words.length - 1][0]}`
  }
  return words[0].slice(0, 2)
}

const isUsableLogo = (url?: string | null) =>
  !!url && (url.startsWith('http://') || url.startsWith('https://'))

const CustomerAvatar = ({ name, logoUrl, size = 28 }: CustomerAvatarProps) => {
  const hasLogo = isUsableLogo(logoUrl)
  const fontSize = Math.max(9, Math.round(size * 0.36))

  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        boxSizing: 'border-box',
        border: `1px solid ${theme.palette.neutral[400]}`,
        borderRadius: '50%',
        bgcolor: hasLogo ? theme.palette.neutral[800] : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.neutral[400],
        fontWeight: 600,
        fontSize: `${fontSize}px`,
        textTransform: 'uppercase',
        overflow: 'hidden',
        flexShrink: 0,
        ['& img']: { objectFit: 'cover' }
      }}
    >
      {hasLogo ? (
        <Image
          src={logoUrl as string}
          alt={`${name || 'cliente'} avatar`}
          width={size}
          height={size}
          style={{ borderRadius: '999px' }}
        />
      ) : (
        getInitials(name)
      )}
    </Box>
  )
}

export default CustomerAvatar
